// tslint:disable:jsx-no-lambda (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-string-literal (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import Radium from '../../styling/rostelecom-radium';
import Color from 'color';
import InternationalizedComponent from '../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../styling/rostelecom-styles-store';
import { IWindowSizeStoreState } from '../../../../../services/window-size/window-size-store';
import { getPropsForField, validateOnFormSubmit } from '../../../../../services/forms/form-helper';
import { ILoginStoreState } from '../../../../../services/login/login-store';
import * as loginActions from '../../../../../services/login/login-actions';
import LoginInput from './elements/login-input';
import LoginButton from './elements/login-button';

// tslint:disable-next-line:no-var-requires no-require-imports (autogenerated)
import zxcvbn from 'zxcvbn';
import { FormattedHTMLMessage } from 'react-intl';
import { IReactRadiumFreeStyles } from '../../../../base/radium-types';

export interface ILoginPageProps {
    styleParams: IRostelecomStyleParamsStoreState;
    windowSize: IWindowSizeStoreState;
    loginStore?: ILoginStoreState;
}

export interface ILoginPageState {
    formState?: any;
    passwordScore?: number;
}

@Radium
class ResetPasswordPage extends InternationalizedComponent<ILoginPageProps, ILoginPageState> {
    // tslint:disable-next-line:typedef (autogenerated)
    constructor(props, opts) {
        super(props, opts);
        this.doResetPassword = this.doResetPassword.bind(this);
        this.initialize();
    }

    public componentDidMount(): void {
        super.componentDidMount();
        /*************************************
************************************************
**********************************************************************************
*********************************/
    }

    private getStyles(): IReactRadiumFreeStyles {
        const styleParams = this.props.styleParams;
        const windowWidth = this.props.windowSize.width;
        const login = this.props.loginStore;
        const passwordScore = this.state.passwordScore;
        let passwordScoreColor = '#FF6600';
        if (passwordScore) {
            passwordScoreColor = '#FF8800';
            if (passwordScore > 1) {
                passwordScoreColor = '#729E11';
            }
            if (passwordScore > 2) {
                passwordScoreColor = '#2A8000';
            }
        }
        const formState: IFormState = this.state.formState;
        const showScore =
            typeof passwordScore === 'number' &&
            formState.showValidationErrorOnFields['newPassword'];
        const visible = login.page === 'reset-password';
        return {
            form: {
                position: visible ? 'relative' : 'absolute',
                zIndex: visible ? 20 : 0,
                opacity: visible ? 1 : 0,
                top: 0,
                left: 0,
                width: '100%',
                transition: 'opacity 0.15s ease-out, z-index 0.15s ease-out'
            },
            subHeader: {
                fontSize: '16px',
                lineHeight: '18px',
                marginTop: 0,
                marginRight: 0,
                marginBottom: 20,
                widthFix: windowWidth,
                marginLeftFix: -(windowWidth - 256) / 2,
                textAlign: 'center',
                padding: 0,
                color: Color(styleParams.neutralColor)
                    .darken(0.6)
                    .hexString()
            },
            checkboxOuter: {
                position: 'relative',
                textAlign: 'left'
            },
            buttonsOuter: {},
            passwordScore: {
                opacity: showScore ? 1 : 0,
                minHeight: 20,
                marginTop: -18,
                fontSize: '12px',
                lineHeight: '16px',
                textAlign: 'left',
                color: passwordScoreColor,
                transition: 'opacity 0.15s ease-out'
            },
            linkStyle: {
                marginTop: 20,
                display: 'block',
                color: styleParams.complementaryMediumDarkColor
            },
            serverError: {
                display: 'block',
                color: styleParams.baseAccentColor,
                minHeight: 16,
                lineHeight: '16px',
                fontSize: '14px',
                marginTop: 8,
                marginBottom: 8
            }
        };
    }

    // tslint:disable-next-line:typedef member-ordering (autogenerated)
    private static passwordRegEpx = /^[a-zA-Z0-9@\-_\.]{5,10}$/;

    // tslint:disable-next-line:member-ordering (autogenerated)
    private formFields: IFormFieldDescriptor[] = [
        {
            id: 'newPassword',
            validate: (value, oldValue) => {
                if (!value || value.length === 0) {
                    this.setState({ passwordScore: undefined });
                    return [this.i18n('js.auth.pages.login.fields.newpassword.required')];
                }
                const { score } = zxcvbn(value);
                if (value && !ResetPasswordPage.passwordRegEpx.test(value)) {
                    this.setState({ passwordScore: undefined });
                    return [this.i18n('js.auth.pages.login.fields.newpassword.invalid')];
                }
                this.setState({ passwordScore: score });
                return [];
            }
        },
        {
            id: 'confirmPassword',
            validate: (value, oldValue, fullValue) => {
                if (!value || value.length === 0) {
                    return [this.i18n('js.auth.pages.login.fields.confirmpassword.required')];
                }
                if (value && fullValue['newPassword'] !== fullValue['confirmPassword']) {
                    return [this.i18n('js.auth.pages.login.fields.confirmpassword.mustbeequal')];
                }
                return [];
            }
        }
    ];

    private getFormDescriptor = (): IFormDescriptor => {
        return {
            value: this.props.loginStore,
            state: this.state.formState,
            onChange: value => {
                loginActions.setLoginState(value);
            },
            onStateChange: state => {
                this.setState({ formState: state });
            },
            fields: this.formFields
        };
    };

    // tslint:disable-next-line:typedef (autogenerated)
    private async doResetPassword(evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        const form = this.getFormDescriptor();
        const loginForm = this.props.loginStore;
        if (validateOnFormSubmit(form, loginForm)) {
            await loginActions.resetPassword(
                loginForm.login,
                loginForm.token,
                loginForm.newPassword
            );
        }
    }

    private goToLogin = (evt: React.FormEvent<HTMLFormElement>) => {
        loginActions.setPage('login');
        if (evt && evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    };

    private renderSuccess(styles: IReactRadiumFreeStyles): JSX.Element {
        const styleParams = this.props.styleParams;
        const login = this.props.loginStore;
        const disabled =
            login.authorizing ||
            login.authorized ||
            login.resettingPassword ||
            login.restoringPassword;
        return (
            <form key="restorePasswordRoot" onSubmit={this.goToLogin} style={styles.form}>
                <h2 style={styles.subHeader}>
                    <FormattedHTMLMessage
                        id="js.auth.pages.login.messages.reset-password-success"
                        values={{ userName: login.login }}
                    />
                </h2>
                <div key="buttons" style={styles.buttonsOuter}>
                    <LoginButton
                        {...{
                            disabled,
                            styleParams,
                            onClick: this.goToLogin,
                            label: this.i18n('js.auth.pages.login.buttons.go-to-login-after-reset')
                        }}
                    />
                </div>
            </form>
        );
    }

    private renderResetTokenValidationError(): JSX.Element {
        const login = this.props.loginStore;
        if (login.resetPasswordTokenValid === true) {
            return null;
        }
        return <div> {this.i18n('js.auth.pages.login.messages.token-invalid')}</div>;
    }

    public render(): JSX.Element {
        const styles = this.getStyles();
        const styleParams = this.props.styleParams;
        const login = this.props.loginStore;
        const form = this.getFormDescriptor();
        const newPasswordProps = getPropsForField(form, 'newPassword');
        const confirmPasswordProps = getPropsForField(form, 'confirmPassword');
        const disabled =
            login.authorizing ||
            login.authorized ||
            login.resettingPassword ||
            login.restoringPassword;
        const score = this.state.passwordScore || 0;
        if (login.resettingPasswordSuccess) {
            return this.renderSuccess(styles);
        }

        const formHidden =
            login.validatingResetPasswordToken || login.resetPasswordTokenValid === false;
        return (
            <form key="resetPasswordRoot" onSubmit={this.doResetPassword} style={styles.form}>
                <h2 style={styles.subHeader}>
                    <FormattedHTMLMessage
                        id="js.auth.pages.login.titles.reset-password"
                        values={{ userName: login.login }}
                    />
                </h2>
                {this.renderResetTokenValidationError()}
                <div hidden={formHidden}>
                    <LoginInput
                        key="new-password"
                        {...{
                            type: 'password',
                            formProps: newPasswordProps,
                            styleParams,
                            disabled
                        }}
                    />
                    <div key="password-score" style={styles.passwordScore}>
                        {this.i18n('js.auth.pages.login.password.score.' + score)}
                    </div>
                    <LoginInput
                        key="confirm-password"
                        {...{
                            type: 'password',
                            formProps: confirmPasswordProps,
                            styleParams,
                            disabled
                        }}
                    />
                    <div key="buttons" style={styles.buttonsOuter}>
                        <div key="serverError" style={styles.serverError}>
                            {login && login.resettingPasswordError}
                        </div>
                        <LoginButton
                            {...{
                                disabled,
                                styleParams,
                                onClick: this.doResetPassword,
                                label: this.i18n('js.auth.pages.login.buttons.reset-password')
                            }}
                        />
                    </div>
                </div>
                <a
                    key="restore-pass-return"
                    style={styles.linkStyle}
                    href="#"
                    onClick={() => loginActions.setPage('login')}
                >
                    {this.i18n('js.auth.pages.login.buttons.go-to-login-from-reset')}
                </a>
            </form>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default ResetPasswordPage;
